export const  PropertyRoutes = {
   
    createProperty: "/properties/property/create",
    getProperty: "/properties/getproperties",
    deleteProperty:"/properties/deleteproperty",
    updateProperty:"/properties/updateproperty",
    getPropertyById:"/properties/getproperty",
    getInvestrorProperty:"/auth/investors/property",

    getPropertyAnalytics:"/properties/property/analytics",
    propertyReportExport: "/api/properties/property/report/export",
    markPropertyAsSold: "/properties/property/sold",
    getClosedDeals:"/properties/closeddeals"
  };
    